import { useTranslation } from 'react-i18next'
import { Button } from '../Button/Button'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import type { EmptyStateProps, OfflineBannerProps, SkeletonProps } from './types'
import './EmptyState.css'

/** Estado vacío o de error (DESIGN.md §4): icono 48, título h3, una frase, acción si procede. */
export function EmptyState({ tone = 'neutral', icon, title, children, actionLabel, onAction, headingLevel, className }: EmptyStateProps) {
  const { t } = useTranslation()
  const isError = tone === 'error'
  const Title: 'h1' | 'h2' | 'h3' | 'div' = headingLevel === 1 ? 'h1' : headingLevel === 2 ? 'h2' : headingLevel === 3 ? 'h3' : 'div'
  return (
    <div className={cx('hp-empty', `hp-empty--${tone}`, className)} role={isError ? 'alert' : undefined}>
      <Icon name={icon ?? (isError ? 'x-circle' : 'circle')} size={48} strokeWidth={1.5} className="hp-empty__icon" />
      <Title className="hp-empty__title">{title}</Title>
      {children && <p className="hp-empty__text">{children}</p>}
      {onAction && (
        <Button variant={isError ? 'primary' : 'secondary'} fullWidth={false} onClick={onAction} className="hp-empty__action">
          {actionLabel ?? t('v2.comun.reintentar')}
        </Button>
      )}
    </div>
  )
}

/** Banner fijo superior "Sin conexión". */
export function OfflineBanner({ children, className }: OfflineBannerProps) {
  const { t } = useTranslation()
  return (
    <div role="status" className={cx('hp-offline', className)}>
      <Icon name="wifi-off" size={20} />
      <span>{children ?? t('v2.ds.offline')}</span>
    </div>
  )
}

/** Esqueleto con el radio del componente real. Nunca spinners de pantalla completa. */
export function Skeleton({ height = 64, radius = 16, width, className, style }: SkeletonProps) {
  return <div aria-hidden="true" className={cx('hp-skeleton', className)} style={{ height, borderRadius: radius, width, ...style }} />
}
